import React, { FC } from 'react'
import { Tab } from '@headlessui/react'
import classNames from 'classnames'
import { GiveawayTabEnum } from '../../../config'
import { GTabText } from '../../UI/Typography'
import { TAB_STYLES } from './constants'
import { TabButtonProps } from './types'

export const TabButton: FC<TabButtonProps> = ({ tab, activeTab, isActive }) => {
  const isActiveInMode = activeTab === tab.type
  const isDetailsDisabled = tab.type === GiveawayTabEnum.Details && !isActive

  return (
    <Tab
      key={tab.title}
      disabled={isDetailsDisabled}
      className={classNames(
        TAB_STYLES.multi,
        isActiveInMode && TAB_STYLES.active,
        isDetailsDisabled && TAB_STYLES.disabled,
      )}
    >
      <GTabText>{tab.title}</GTabText>
    </Tab>
  )
}
